import React from 'react'
import {Skeleton} from 'antd'
import './skeleton-style.scss'

export default function HeadingSkeleton({ height,  maxWidth, block, size  }) {
  return (
    <>
        <div className={'heading-skeleton w-100'}
             style={{  maxWidth: maxWidth, overflow:"hidden"}}
        >
        <Skeleton.Input
          active={true}
          style={{

            height: height,
          }}
          block={block ? block :true}
            size={size ? '' : size}
        />
      </div>
    </>
  )
}
